import React from 'react';
import { motion } from 'framer-motion';
import { DonateModule } from './DonateModule';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-24 pb-16 overflow-hidden" data-id="element-98">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-99">
        <img src="https://images.unsplash.com/photo-1509316785289-025f5b846b35?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Arizona Desert Landscape" className="w-full h-full object-cover object-center" data-id="element-100" />
        <div className="absolute inset-0 bg-gradient-to-r from-pac-navy/95 via-pac-navy/80 to-pac-navy/40 mix-blend-multiply" data-id="element-101" />
        <div className="absolute inset-0 bg-pac-navy/40" data-id="element-102" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-103">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-104">
          {/* Text Content */}
          <div className="lg:col-span-7 text-white" data-id="element-105">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-106">
              <div className="inline-block bg-pac-gold text-pac-navy font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider mb-6" data-id="element-107">
                Urgent: Deadline Approaching
              </div>
              <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-6 drop-shadow-lg" data-id="element-108">
                Defending <span className="text-pac-gold" data-id="element-109">Local Control</span>{' '}
                in the West Valley.
              </h1>
              <p className="text-xl sm:text-2xl text-slate-200 mb-8 max-w-2xl font-light leading-relaxed drop-shadow-md" data-id="element-110">
                We are a coalition of leaders fighting for smart zoning,
                community safety, and a high quality of life for Maricopa County
                residents.
              </p>

              <div className="flex flex-wrap gap-4" data-id="element-111">
                <a href="#mission" className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-pac-navy px-8 py-4 rounded font-bold uppercase tracking-wider transition-all" data-id="element-112">
                  Read Our Mission
                </a>
              </div>
            </motion.div>
          </div>

          {/* Donate Module */}
          <div className="lg:col-span-5" data-id="element-113">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-114">
              <DonateModule data-id="element-115" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}